import styles from './ContentSection.module.css';

export default function KitoContentSection({
  title,
  prevIcon,
  border,
  variant,
  children,
}) {
  return (
    <section
      className={styles.container}
      data-border={border}
      data-variant={variant}
    >
      <article className={styles.content}>
        {title && (
          <h3 className={styles.title}>
            {prevIcon && (
              <img
                className={styles.prevIcon}
                src={prevIcon}
                alt="title-icon"
              />
            )}
            {title}
          </h3>
        )}
        <div className={styles.children}>{children}</div>
      </article>
    </section>
  );
}
